import { LevelSource } from '~/curriculum/constants/curriculum.const'

import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

import { CurriculumEvents } from './curriculumEvents.types'

class CurriculumAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.CURRICULUM)
  }

  public logCurriculumClick(
    event: CurriculumEvents,
    params: Record<string, string | number | boolean | undefined> = {},
    version: string = 'v2',
  ): void {
    this.logEvent({
      event,
      version,
      ...params,
    })
  }

  public logSelectGradeClick(
    grade: number,
    options: { gradeLabel?: string; fromOnboarding?: boolean; version?: string } = {},
  ): void {
    const { gradeLabel, fromOnboarding, version = 'v2' } = options
    this.logEvent({
      event: CurriculumEvents.GRADE_SELECTED,
      grade,
      ...(gradeLabel !== undefined && { grade_label: gradeLabel }),
      ...(fromOnboarding !== undefined && { from_onboarding: fromOnboarding }),
      version,
    })
  }

  public logSwitchCurriculum(direction: 'previous' | 'next', from_grade: number): void {
    this.logEvent({
      event: CurriculumEvents.ADJACENT_GRADE_NAVIGATED,
      direction,
      from_grade,
    })
  }

  public logGradeLevelClick(
    type: 'bootcamp' | 'ai_prompt' | 'math_vault',
    title: string,
    gradeLevelDetails?: {
      level?: string
      subjectId?: string
      bootcampId?: string
      prompt?: string
      globalId?: string
      source?: LevelSource.CURRICULUM | LevelSource.PRE_REQUISITE
    },
    version: string = 'v2',
  ): void {
    this.logEvent({
      event: CurriculumEvents.CURRICULUM_LEVEL_OPENED,
      level_kind: type,
      title,
      version,
      ...gradeLevelDetails,
    })
  }

  public logSystemUpdateConfirmed(): void {
    this.logEvent({
      event: CurriculumEvents.SYSTEM_UPDATE_CONFIRMED,
      title: 'system_update_modal',
    })
  }
}

const curriculumAnalytics = new CurriculumAnalytics()

export default curriculumAnalytics
